export const isAuthenticated = (state) => {
  return state.auth.isAuthenticated;
};

export const isCompanySelected = (state) => {
  if (state.auth.selectedCompany && state.auth.selectedCompany.companyId) return true;
  return false;
}

export const getSelectedCompany = (state) => {
  if (state.auth.auth.selectedCompany && state.auth.auth.selectedCompany.companyId)
    return state.auth.auth.selectedCompany;
  else
    return '';
};

export const getAccessToken = (state) => {
  if (state.auth.auth._tokenResponse.idToken)
    return state.auth.auth._tokenResponse.idToken;
  else
    return '';
};

export const getRefreshToken = (state) => {
  if (state.auth.auth._tokenResponse.refreshToken)
    return state.auth.auth._tokenResponse.refreshToken;
  else
    return '';
}

export const getExpiresIn = (state) => {
  if (state.auth.auth._tokenResponse.expiresIn)
    return state.auth.auth._tokenResponse.expiresIn;
  else
    return '';
}


export const getUid = (state) => {
  if (state.auth.user && state.auth.user.googleUid)
    return state.auth.user.googleUid;
  else
    return '';
};